import React, { useRef, useEffect, useCallback, useState} from 'react';
import {initializeEffect, effectOptions} from 'components/effects/constants.js';
import {useColors} from "components/hooks/useColors.js";
import AudioFXMenu from "components/pulled/AudioFXMenu.js";
import {useContextMenu} from "components/dropdowns/useContextMenu.js";
import EffectInput from './EffectInput.js';
import EffectOutput from './EffectOutput.js';
import {useWindowManager} from "components/windows/useWindowManager.js";

import {connect} from 'react-redux';

const Speakers = ({isMidi, pad, isSelected, coords, ...props}) => { 
    const ref = useRef(undefined);
    
    const {onContextMenu, dropdownPos, setDropdownPos} = useContextMenu({ref});
    const dropdownPosRef = useRef({x:0, y:0});

    const windowMgmt = useWindowManager({
        ref: ref,
        element: pad.effectRack && pad.effectRack.outputNode,
        windowPosition: coords,
        sequencerEngine: pad.sequencerEngine,
        ...props
    });

    let {style, isDragging, onMouseDown, onMouseUp, setCoords}  = windowMgmt;

    const colorStyle = useColors({id: pad && pad.effectRack && pad.effectRack.id});

    useEffect(() => {
        if (coords) {
            dropdownPosRef.current = {
                x: coords.x + 150,
                y: coords.y + 150,
            };
        }
    }, [coords]);
    let className = "pad-effect-control speakers";
    if (isSelected) {
        className += " selected";
    }

    let _style = {
        ... style,
        ... colorStyle
    };
    if (isMidi) {
        delete _style['backgroundColor'];
        className += " midi-speakers";
    }
    if (coords) {
        _style.left = coords.x;
        _style.top = coords.y;
    }

    if (!pad || !pad.effectRack) {
        return '';
    }
    return [
        <div
          key={1}
          onContextMenu={(e) => {
              onContextMenu(e);
              windowMgmt.onContextMenu(e);
          }}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          ref={ref}
          style={_style}
          className={className}>
          {isMidi ? <div className="speaker-name">
                      Out
                    </div>: <img draggable={false} src="/speakers.svg"/>}
          {!isMidi ?
           <AudioFXMenu
             effectOptions={effectOptions}
             initializeEffect={initializeEffect}
             dropdownPosRef={dropdownPosRef}
             dropdownPos={dropdownPos}
             setDropdownPos={setDropdownPos}
             node={pad}/> : ''}
          <EffectInput isSpeaker={true} id={pad.effectRack.id + '-speakers'} containerRef={props.containerRef} pad={pad} fx={pad.effectRack.outputNode}/>
        </div>,
    ];
}

const mapStateToProps = (state, props) => {
    let effectRack = props.pad.effectRack;
    if (!effectRack) {
        return {
        };
    };
    return {
        coords: state.windows.windowPositions[props.pad.effectRack.outputNode.id],
        isSelected: state.windows.selectedElements[props.pad.effectRack.outputNode.id],
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Speakers);
